import ResumeDistributionEditView from './ResumeDistributionEditView'
export default ResumeDistributionEditView
